
import React, { useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';

import styles from './terms-and-con.module.scss';


const TermsAndCon = ({nextStep}) => {

  const [checkboxState, setCheckboxState] = useState(false);

  const handleCheckBoxChange = () => {
    setCheckboxState(!checkboxState);
  }

  //Handle redirect to privacy notice
  const redirectToTerms = () => {
    const newWindow = window.open(`${process.env.REACT_APP_CLIENT_ENDPOINT}/terms-conditions`, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  return (
    <Row>
      <Col>
        <div className={styles['terms-con-component']}>
          <div className={styles['terms-con-component-panel']}>

            <div className={styles['terms-con-component-panel-header']}>
              Electronic ATP Representation, Warranties and Authorization
            </div>
            <div className={styles['terms-con-component-panel-body']}>
              <p>
                In executing this Application, the Applicant-Client represents and warrants, under penalty of law, that all
                information contained herein (including its tax status) are true and correct and that
                the creation and generation of Electronic Documents on the e-SIP by the Applicant,
                are executed with full authority and shall be binding without need of physical signature of the
                individual Applicant who is a natural person
              </p>
              <p>
                The Applicant agrees to immediately notify the Issuer and the Registrar and Paying Agent, either
                directly or through any of the Underwriters and Selling Agents, if anything occurs which renders or
                may render untrue or incorrect in any respect any of the information given herein (including
                information given with respect to the Applicant’s tax status) or any of its representations or
                warranties. The Applicant understands that any of the Underwriters, Selling Agents, the Registrar and
                Paying Agent and the Issuer will rely solely on its representations and warranties set forth herein
                including, without limitation, its declaration of its tax status, including, if applicable, its
                tax-exempt status in processing payments due to it under the Offer Bonds. The Applicant agrees
                to indemnify and hold any of the Underwriters, the Selling Agents, the Registrar and Paying Agent,
                and the Issuer free and harmless against any and all claims, actions, suits, damages, and liabilities
                resulting from the non-withholding of the required tax due to the representations as indicated in this
                Application, any misrepresentation contained herein or any reliance on the confirmations contained
                herein. The Applicant likewise authorizes the Registrar and Paying Agent to verify the information
                stated in this Application from any and all sources and in any and all manner, including but not
                limited to, requesting information contained herein from the Underwriter or Selling Agent regarding
                the Applicant’s account/s with the said Underwriter or Selling Agent (as applicable). By giving
                authority to the Registrar and Paying Agent and by submitting this application through the e-SIP
                by signing this application, the Applicant hereby gives its consent to the disclosure of or inquiry
                into its private and confidential information as provided by law or by contract including Republic
                Act No. 1405 (The Bank Secrecy Act of 1955), as amended, and allows the Underwriters and Selling
                Agents to disclose all information as may be required by the Issuer and the Registrar and Paying Agent,
                solely and exclusively for the limited purpose of enabling the Registrar and Paying Agent to perform
                its functions as registrar and paying agent of the Issuer in the manner contemplated under the
                Registry and Paying Agency Agreement (the “RPAA”), including but not limited to, creating a
                registry account for the Applicant and updating the Applicant’s information in the Registry
                with respect to the information contained herein.  The Applicant further authorizes the Registrar
                and Paying Agent and the Underwriters to collect, process, retain, share, dispose and
                destroy such information that are required to enable the Registrar and Paying Agent to carry out their
                duties under the RPAA, including personal, sensitive or privileged information of such Applicant.
                In addition, by signing this application, by submitting this application through the e-SIP the Applicant
                hereby (i) consents to the collection, processing, retention, sharing, disposal and destruction
                by the Registrar and Paying Agent on behalf of the Issuer of the information contained
                herein (the “Information”) and (ii) acknowledges receipt of notice of and consents to the following:
              </p>
              <ol className={styles['alpha']}>
                <li>
                  <div>
                    The Registrar and Paying Agent, in its capacity as registrar and paying agent of the Offer
                    Bonds, and the Underwriters shall collect, process, retain, share, dispose and destroy the
                    Information in accordance with the Data Privacy Act of 2012 and its Implementing Rules and
                    Regulations (“IRR”).
                  </div>
                </li>
                <li>
                  <div>
                    The Registrar and Paying Agent and the Underwriters shall not sell, trade or otherwise share the
                    Information for marketing purposes to third parties without the consent of the Applicant.  The
                    Registrar and Paying Agent and the Underwriters may disclose the Information to:
                    <ol className={styles['numeric']}>
                      <li>
                        <div>
                          government or regulatory agencies if required by applicable law or by an order of government
                          or regulatory agency or if reasonably determined by the Registrar and Paying Agent to be
                          necessary in relation to the use of the Information in connection with the provision of
                          any service related to this Applicant’s registry account and for data processing, storage,
                          retention, collection, sharing, disposal and destruction as may be necessary for the
                          provision of such service, anti-money laundering monitoring, review and reporting and
                          for purposes of complying with any law or regulation (the “Purpose”), for law enforcement
                          purposes, national security or public interest;
                        </div>
                      </li>
                      <li>
                        <div>
                          its employees, directors, officers, representatives, agents and service providers if the
                          Registrar and Paying Agent and the Underwriters deem it reasonably necessary in relation to
                          the Purpose; and
                        </div>
                      </li>
                      <li>
                        <div>
                          its subsidiaries and affiliates as well as employees, directors, officers, representatives,
                          agents and service providers of such subsidiaries and affiliates if the Registrar and Paying
                          Agent and the Underwriters deem it reasonably necessary in relation to the Purpose.
                        </div>
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <div>
                    The Applicant has rights and remedies relating to the processing of the Information under the
                    Data Privacy Act of 2012, its IRR and under applicable laws, such as, but not limited to the right
                    to access the Information in accordance with the procedures of the Registrar and Paying Agent,
                    and the Underwriters to have it corrected in accordance with the procedures of the Registrar and
                    Paying Agent and the Underwriters and to file a complaint with the appropriate government
                    agency.  Please refer to the National Privacy Commission for details of such rights and remedies.
                  </div>
                </li>
                <li>
                  <div>
                    The Applicant may address any concerns or questions regarding the processing of the Information
                    to the Data Privacy Officer of the relevant (i) Registrar and Paying Agent, (ii) Underwriters,
                    and/or (iii) Selling Agents, if any.
                  </div>
                </li>
              </ol>
              <p>
                The Applicant further accepts the following terms:
              </p>
              <p className={styles['bold']}>
                Email Indemnity
              </p>
              <p>
                I/we consent to receive all notice and communications via email, and such consent shall operate
                as of the written consent to disclose or inquire into my bank deposits in respect of such
                statements or notices. I/we acknowledge that security of any statement, notice or communication
                sent through electronic means is not guaranteed and I/we assume all risks in relation to its
                transmission. I/We are responsible for keeping such email access active and existing during
                the term of the Offer Bonds, otherwise, I/we shall be liable for any fees or charges that maybe
                imposed or incurred in transmitting or re-transmitting such communication via electronic means.
              </p>
              <p className={styles['bold']}>
                Authorization Granted to the Registrar and Paying Agent
              </p>
              <p>
                All payments under the Offer Bonds shall be credited to the Cash Settlement Account. I/We shall
                be responsible for ensuring that this account is open, active and existing, otherwise, I/we shall
                be liable for any fees or charges that may be imposed by the Cash Settlement Bank or that may
                otherwise be incurred by the Registrar and Paying Agent in crediting payments of interest or
                principal to my/our account.  This shall remain valid and effective unless expressly revoked
                in writing by me/us in the manner prescribed under relevant rules and/or agreements.
              </p>
              <p>
                In the event that the details of the Cash Settlement Account are incomplete or erroneous, or the Cash
                Settlement Account of the Bondholder has been closed, dormant, or inexistent, due to which payments
                to the Bondholder cannot be effected in a timely manner, and the Paying Agent does not receive any
                notice from the Bondholder as described herein, the Cash Settlement Bank shall handle such funds in
                accordance with its own internal procedures until the correction in the Cash Settlement Bank is
                effected and until credit of the relevant cash entitlement is completed. In these cases, the Issuer
                and the Registrar and Paying Agent shall not be liable to the relevant Bondholder for any failure or
                delay in the Bondholder’s receipt of such payments.
              </p>
              <p>
                The Applicant warrants that the Applicant (or its authorized signatory) has read and understood the
                PDTC Rules, the terms and conditions of the Offer Bonds (the “Terms and Conditions”), the
                Prospectus and the Offer Supplement (as applicable) distributed or made available by the Issuer and
                the underwriters and selling agents in relation to the offer and sale of the Offer Bonds, and
                unconditionally accepts the same. The Applicant agrees to indemnify and hold the Registrar and
                Paying Agent, the Issuer, the underwriters and the selling agents, free and harmless from and against
                any and all liabilities, damages, penalties, judgments, suits, expenses and other costs of any kind
                or nature arising from any act or omission pertinent to their respective obligations under the Offer
                Bonds, unless such act or omission was committed with gross negligence or willful misconduct.
                The Applicant further agrees that completion of this Application to Purchase constitutes an
                instruction and authority from the Applicant to the Issuer, the Registrar and Paying Agent,
                and/or underwriters and selling agents to execute any application form or other documents and
                generally to do all such other things and acts as the Issuer, the Registrar and Paying Agent,
                and/or underwriters and selling agents may consider necessary or desirable to effect registration
                of the Offer Bonds in the name of the Applicant.
              </p>
              <p>
                The Applicant represents and warrants to the Issuer, the Underwriters and the Selling Agents and
                the trustee of the Issue (the “Trustee”) that it has independently and, without reliance on the
                Issuer, the Underwriters and/or the Selling Agents or the Trustee, made its own credit investigation
                and appraisal of the financial position and affairs of the Issuer on the basis of such documents and
                information it has deemed appropriate and that it has subscribed to the Offer Bonds on the basis of
                such independent appraisal, and that it shall continue to make its own credit appraisal without
                reliance on the Issuer, the Underwriters and/or the Selling Agents or the Trustee.
              </p>
              <p className={styles['bold']}>
                Cooling-Off Period
              </p>
              <p>
                Within two (2) Business Days from submission of the duly executed Application to the Issuer
                (the “Cooling-Off Period”), the Applicant, who is a natural person, is allowed to cancel,
                in whole or in part, the Application by providing the Underwriter or Selling Agent within the same
                period a written notice of such decision to cancel the Application (the “Written Notice of Cancellation”)
                indicating in such written notice: (a) the amount of the [Issue] to be cancelled, (b) the amount of
                the [Issue] to be retained (so long as the same complies with the minimum denomination requirements
                under the Terms and Conditions), and (c) the reason for such cancellation. In case the Applicant provides
                the Underwriter or Selling Agent with a Written Notice of Cancellation in the manner set forth above,
                the cancellation shall be without penalty but shall entitle the Issuer and the Underwriter or Selling
                Agent to charge and collect reasonable amount of fees (including, but not limited to, processing and/or
                administrative fees plus any mark-to-market costs) incurred from the time of submission of the duly
                executed Application up to time of cancellation of the purchase of the [Issue]. The Applicant
                recognizes that the amount of fees to be collected by the Issuer and the Underwriter or Selling Agent
                in the event of cancellation of the [Issue] have been disclosed to the Applicant prior to his or
                its execution of this Application and the Applicant fully understands the effect of said cancellation
                and the nature and amount of fees (or the manner of computing the fees) to be collected. Further,
                in case the Applicant partially cancels his/its purchase of the [Issue], the Application of the
                relevant Applicant shall be deemed to have been amended to reflect that the purchase of the [Issue]
                is being made only to the extent and in such amounts indicated in the Written Notice of Cancellation
                as the amount of the [Issue] that the Applicant intends to retain or purchase. For which purpose,
                the Applicant authorizes the Underwriter or Selling Agent to execute such documents
                or contracts to effect such amendment of this Application.
              </p>
              <p>
                The Applicant acknowledges that this Application, upon acceptance by the Underwriters and/or
                Selling Agents, in behalf of the Issuer, constitutes a duly executed purchase agreement covering the
                [Issue] purchased, valid and binding on the Applicant under the stipulations hereof and the related
                contracts.  After the Cooling-Off Period, it may not be unilaterally revoked or cancelled by the
                Applicant, in full or in part, and the rights and privileges pertaining thereto are non-transferable,
                until after the issuance of the Registry Confirmation by the Registrar and Paying Agent.  In accordance
                with applicable banking regulations, the Applicant acknowledges that the Cooling-Off Period shall not
                apply to: (a) Applicants with aggregate investments in the [Issue] of Five Hundred Thousand
                [Philippine Pesos] ([Php500,000.00]) or more, and (b) such securities deemed
                to be “traded” or “to be traded.”
              </p>
              <p className={styles['bold']}>
                Eligible Holders and Loss Absorbency Feature
              </p>
              <p>
                The Applicant understands that the Issuer intends to issue the [Issue] in accordance with the Terms
                and Conditions, Offering Circular, this Application to Purchase, the Purchase Advice and the
                Registry Confirmation (collectively, the “Documents”), and Section 126 of the Manual of
                Regulations for Banks (the “Manual”) issued by the BSP and BSP Circular Nos. 826 (series of 2014),
                781 (series of 2013), 786 (series of 2013), 778 (series of 2012) and other circulars and regulations
                that may be relevant to the proposed issuance (collectively, “BSP Rules”), as part of the Bank’s
                compliance with Basel III capital guidelines of BSP.
              </p>
              <p>
                The Applicant hereby represents and warrants to the Issuer, the Underwriters and/or the Selling Agents
                that the Applicant has read and fully understands the Risk Disclosure Statement, the Documents, and
                the BSP Rules as to, inter alia, the obligations of the parties and the possible benefits and risks
                of investing in the [Issue], including the loss absorbency features of the [Issue] and the restriction
                that the [Issue] may only be held by or transferred to Eligible Holders, namely, all prospective
                purchasers of the [Issue] other than Prohibited Holders.
              </p>
            </div>

            <div className={styles['terms-con-component-panel-check']}>
              <label>
                <input type="checkbox" onChange={()=>{handleCheckBoxChange()}} checked={checkboxState}/>
                The Applicant agrees to be bound by
                the{' '}<span className={styles['statement-link']} onClick={() => redirectToTerms()}>Terms & Conditions</span>{' '}for the Use of the e-SIP.
              </label>
            </div>

            <div className={styles['terms-con-component-panel-action']}>
              <Row>
                <Col>
                  <Button variant="secondary" onClick={()=>nextStep(true)}>BACK</Button>
                  <Button onClick={()=>nextStep()} disabled={!checkboxState}>NEXT</Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  )

}


export default TermsAndCon;



